import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services/api';

export type GetTagSettingsResponse = {
  allowed_colors: string[];
};

export const useGetTagSettings = () => {
  return useQuery({
    queryKey: ['tagSettings'],
    queryFn: () =>
      api
        .get<GetTagSettingsResponse>('/v3/tag/settings')
        .then(({ data }) => data),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
